import React from "react";
import { Text, View, TextInput, StyleSheet } from "react-native";
import { Button } from "../Button";
import { Colors } from "@constants";
import { I18n } from "react-redux-i18n";

type Step3CodeProps = {
  code: string;
  onCodeChange: (code: string) => void;
  onVerify: () => void;
  loading: boolean;
  error?: string;
  onPrevStep: () => void;
};

export default function Step3Code({
  code,
  onCodeChange,
  onVerify,
  loading,
  error,
  onPrevStep,
}: Step3CodeProps) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {I18n.t("profile.mfa.activate.step3.title")}
      </Text>
      <Text style={styles.desc}>
        {I18n.t("profile.mfa.activate.step3.description")}
      </Text>
      <TextInput
        style={styles.input}
        keyboardType="number-pad"
        value={code}
        onChangeText={onCodeChange}
        placeholder="123456"
        maxLength={6}
        autoFocus
      />
      {!!error && <Text style={styles.error}>{error}</Text>}
      <View style={styles.buttonRow}>
        <Button type="secondary" onPress={onPrevStep}>
          {I18n.t("profile.mfa.activate.step3.previousStep")}
        </Button>
        <Button
          type="primary"
          onPress={onVerify}
          disabled={loading || !code || code.length < 6}
        >
          {I18n.t("profile.mfa.activate.step3.activate")}
        </Button>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { alignItems: "center", padding: 16 },
  title: { fontSize: 18, fontWeight: "bold", marginBottom: 13 },
  desc: { textAlign: "center", marginBottom: 16, color: "#444" },
  input: {
    width: 120,
    borderColor: "#888",
    borderWidth: 1,
    borderRadius: 4,
    padding: 8,
    textAlign: "center",
    marginBottom: 22,
  },
  error: { color: Colors.redError, marginBottom: 12 },
  buttonRow: { flexDirection: "row", gap: 12 },
});
